module.exports = "<div ng-if=vm.isEnabled class=\"google-ad-slot advert\" ng-show=vm._adLoaded id=\"{{ vm.tagname }}\"> </div> ";